export default "__VITE_ASSET__dcc0ca66__"